import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * ScrollToTop — reset scroll to the top of the viewport on every
 * client-side route change. Mount ONCE inside <BrowserRouter>.
 *
 * Why: React Router does not restore scroll on navigation. Users
 * clicking a footer link (which lives at the bottom of the previous
 * page) land on the new page at the OLD scroll offset — the content
 * they came to see is already above them.
 *
 * The `hash` guard preserves in-page anchor jumps (e.g. `#pricing`).
 */
export default function ScrollToTop() {
    const { pathname, hash } = useLocation();
    useEffect(() => {
        if (hash) return; // let the browser jump to the anchor
        // `instant` avoids the jarring animation when navigating between pages.
        try {
            window.scrollTo({ top: 0, left: 0, behavior: "instant" });
        } catch {
            window.scrollTo(0, 0);
        }
    }, [pathname, hash]);
    return null;
}
